module.exports = __webpack_public_path__ + "static/article-placeholder-3527740e16f4353181d8c6d0b1936fe1.png";